import {
    IonButton,
    IonContent,
    IonGrid,
    IonHeader, IonItem, IonLabel, IonList,
    IonPage,
    IonText,
} from '@ionic/react';
import {Toolbar} from "../pages/Toolbar";
import React, {useContext} from "react";
import logo from '../resources/logo-primary.svg';
import {Redirect, useHistory} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";
import { useUserPermissions } from "../authorisation/authorisation-hook";

export default function Home() {

    const history = useHistory();
    const { permissions } = useUserPermissions();

    if (!permissions.canViewJobs) {
        return (
            <Redirect to="/bookings" />
        );
    }

    return (
        <IonPage>
            <IonHeader>
                <Toolbar title='Home' />
            </IonHeader>
            <IonContent>
                <IonGrid class='homeGrid'>
                    <IonList lines='full'>
                        <IonItem button={false} className='homeBtn'
                                 lines='full'
                        >
                            <img
                                src={logo}
                                alt="Logo"
                            />
                        </IonItem>
                        <IonItem button={true} className='homeBtn' onClick={(e) => {
                            e.stopPropagation();
                            history.push(`/jobs`);
                        }} detail
                                 lines='full'
                        >
                            <IonLabel>
                                <h1>
                                    <strong>
                                        Cleaning jobs
                                    </strong>
                                </h1>
                                <IonText>
                                    Cleans completed by you that are invoiced via Travel Chapter.
                                </IonText>
                            </IonLabel>

                            <IonButton
                                fill='clear'
                                size='small'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    history.push(`/jobs`);
                                }}
                            >
                            </IonButton>
                        </IonItem>
                        <IonItem button={true} className='homeBtn' onClick={(e) => {
                            e.stopPropagation();
                            history.push(`/bookings`);
                        }} detail
                                 lines='full'
                        >
                            <IonLabel>
                                <h1>
                                    <strong>
                                        Bookings
                                    </strong>
                                </h1>
                                <IonText>
                                    All guest and owner bookings across all the properties you service with Travel Chapter (whether directly with the owner or through Property Management)
                                </IonText>
                            </IonLabel>

                            <IonButton
                                fill='clear'
                                size='small'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    history.push(`/bookings`);
                                }}
                            >
                            </IonButton>
                        </IonItem>
                    </IonList>
                </IonGrid>
            </IonContent>
        </IonPage>
  );
}
